import {useMemo} from "react";
import Marquee from "react-fast-marquee";

const OPENING_HOURS = {
    1: [[8 * 60, 12 * 60], [15 * 60, 18 * 60]], // Montag
    2: [[8 * 60, 16 * 60]],                     // Dienstag
    3: [[8 * 60, 12 * 60]],                     // Mittwoch
    4: [[8 * 60, 12 * 60], [15 * 60, 18 * 60]], // Donnerstag
    5: [[8 * 60, 12 * 60]],                     // Freitag
    6: [],                                      // Samstag
    0: [],                                      // Sonntag
};

const DAY_NAMES = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];

function formatRange([start, end]) {
    const fmt = (min) =>
        `${String(Math.floor(min / 60)).padStart(2, "0")}:${String(min % 60).padStart(2, "0")}`;
    return `${fmt(start)}–${fmt(end)}`;
}

export function OpeningHoursBanner() {
    const {isOpen, todayText} = useMemo(() => {
        const now = new Date();
        const day = now.getDay();
        const minutesNow = now.getHours() * 60 + now.getMinutes();
        const ranges = OPENING_HOURS[day];

        const open = ranges.some(([start, end]) => minutesNow >= start && minutesNow < end);
        const text =
            ranges.length > 0
                ? `${DAY_NAMES[day]}: ${ranges.map(formatRange).join(" / ")}`
                : `${DAY_NAMES[day]}: Geschlossen`;

        return {isOpen: open, todayText: text};
    }, []);

    return (
        <Marquee
            speed={50}
            gradient={true}
            pauseOnHover={true}
            style={{backgroundColor: isOpen ? "#b8d4ed" : "#f4e6e6"}}
        >
            &nbsp;{isOpen ? "Praxis derzeit geöffnet" : "Praxis derzeit geschlossen"} &nbsp;|&nbsp; {todayText} &nbsp;|&nbsp; Termine
            nach Vereinbarung
        </Marquee>
    );
}